<template>
  <div class="home">
    <div id="stats-table" class="data-table" border="1">
      <div class="header">
        <div>ID</div><div>Skill</div><div>Config</div><div>Count LT</div><div style="min-width: 150px">Range EUR</div><div>Count PL</div><div style="min-width: 150px">Range PLN</div><div>Hidden</div><div>Biz EUR</div><div>Actions</div>
      </div>
      <div v-for="skill in stats" v-bind:key="skill.id" class="row">
        <div class="cell">{{skill.id}}</div>
        <div class="cell"><router-link :to="{ name: 'skillPage', params: { id: skill.id }}">{{skill.title || skill.id}}</router-link></div>
        <div class="cell" v-html="skill.config"></div>
        <div class="cell" v-html="getCounts(skill.id, 'LT')"></div>
        <div class="cell" style="min-width: 150px">
          {{rangesLT[skill.id]}}
          <VueSlider :minRange="0" :maxRange="100" v-model="rangesLT[skill.id]" @drag-end="dirtySkill(skill.id)" />
        </div>
        <div class="cell" v-html="getCounts(skill.id, 'PL')"></div>
        <div class="cell" style="min-width: 150px">
          {{rangesPL[skill.id]}}
          <VueSlider :min="0" :max="300" v-model="rangesPL[skill.id]" @drag-end="dirtySkill(skill.id)"/>
        </div>
        <div class="cell">{{skill.hidden ? 'TRUE' : ''}}</div>
        <!-- <div class="cell">{{skill.priceStats.from.EUR / 100}}</div> -->
        <div v-if="skill.hourlyRate2" class="cell"  style="background-color: #c7fac3">{{skill.hourlyRate2 ? Number(skill.hourlyRate2.LT.EUR / 100) : ''}} <span v-if="skill.hourlyRate">+{{skill.hourlyRate ? (Number(skill.hourlyRate2.LT.EUR - skill.hourlyRate.LT.EUR) / 100) : ''}}</span></div>
        <div  class="cell" v-else>{{skill.hourlyRate ? Number(skill.hourlyRate.LT.EUR / 100) : ''}}</div>
        <div class="cell"><button v-if="dirty[skill.id]" class="button" @click="updateSkill(skill.id)">SAVE</button></div>
      </div>
    </div>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<style scoped lang="less">
#stats-table{
  grid-template-columns: auto auto auto auto auto auto auto auto auto auto;
}
.button {
  cursor: pointer;
}
.cell {
  padding: 5px;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from '../services/api';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export const cities = [
  {
    code: 'vilnius',
    name: 'Vilnius',
    country: 'LT',
    currency: 'EUR',
    defaultAreaRadius: 20000,
    language: 'lt',
    location: {lat: 54.687157, lng: 25.279652}
  },
  {
    code: 'kaunas',
    name: 'Kaunas',
    country: 'LT',
    currency: 'EUR',
    defaultAreaRadius: 20000,
    language: 'lt',
    location: {lat: 54.898521, lng: 23.903597},
  },
  {
    code: 'klaipeda',
    name: 'Klaipėda',
    country: 'LT',
    currency: 'EUR',
    language: 'lt',
    defaultAreaRadius: 20000,
    location: {lat: 55.703297, lng: 21.144279},
  },
  {
    code: 'warsaw',
    name: 'Warszawa',
    country: 'PL',
    currency: 'PLN',
    language: 'pl',
    defaultAreaRadius: 20000,
    location: {lat: 52.229676, lng: 21.012229},
  },
];

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  // console.log('Distance between', lat1, lon1, lat2, lon2, 'is', d);
  return d;
}

function proCoversArea(city, pro) {
  const serviceArea = pro.serviceArea;
  const distance = getDistanceFromLatLonInKm(
    serviceArea.latitude,
    serviceArea.longitude,
    city.location.lat,
    city.location.lng,
  );
  // console.log('distance', distance, serviceArea.radius);
  if (distance <= serviceArea.radius / 1000) {
    return true;
  }
  return false;
}

export default {
  name: 'home',
  data: function() {
    return {
      stats: [],
      pros: [],
      rangesLT: {},
      rangesPL: {},
      skills: {},
      dirty: {}
    }
  },
  components: {
    VueSlider
  },
  methods: {
    updateSkill: async function(skillId) {
      // this.skills.$set(skill.index, skill);
      const stats = {
        priceStats: {
          limit: {
            PLN: this.rangesPL[skillId][1] * 100,
            EUR: this.rangesLT[skillId][1] * 100
          },
          minimum: {
            PLN: parseInt(this.rangesPL[skillId][0] * 100 * 0.8),
            EUR: parseInt(this.rangesLT[skillId][0] * 100 * 0.8)
          }
        }
      };
      console.log(skillId, stats);
      await api.updateSkill(skillId, stats, {});
      this.dirty[skillId] = false;
      this.$forceUpdate();
      // console.log(skill.priceStats);
    },
    getCounts(skillId, country) {
      let text = "";
      let range = this['ranges' + country][skillId];
      for(let i = 0; i < cities.length; i++) {
        const city = cities[i];
        if (city.country !== country) {
          continue;
        }
        let cityProCount = 0;
        let limitedProCount = 0;
        let from = 10000000;
        this.pros.forEach(pro => {
          if (pro.serviceArea && pro.skills && pro.serviceArea.country === country && proCoversArea(city, pro) && pro.skills.indexOf(skillId) !== -1) {
            cityProCount++;
            const rate = pro.skillSettings[skillId].rate;
            if (rate / 0.8 < from) {
              from = rate / 0.8;
            }
            if (rate / 0.8 <= range[1] * 100) {
              limitedProCount++;
            }
          }
        });
        if (from !== 10000000) {
          text += "<span style='color:green'>" + (from / 100) + "</span>";
        }
        text += " " + city.name;
        text += " " + cityProCount + "<b>["+ limitedProCount + "]</b>" + "<br />";
      }
      return text;
    },
    dirtySkill(skillId) {
      // console.log('change', skillId);
      this.dirty[skillId] = true;
      this.$forceUpdate();
    },
  },
  created: async function() {
    document.title = 'Skills';
    const users = await api.getPros();
    this.pros = users;
    const stats = Object.values(users).filter(u => (u.verified && !u.ordersDisabled)).reduce((prev, next) => {
      if (next.skills) {
        next.skills.forEach(skillId => {
          const skills = this.$store.state.skills;
          const priceStats = Object.assign({limit: {EUR: 0}}, skills[skillId].priceStats);
          const rate = parseInt(next.skillSettings[skillId].rate);
          const country = next.serviceArea.country === 'PL' ? 'PL' : '';
          if (!prev[skillId]) {
            prev[skillId] = {count: 0, countPL: 0, min: 0, minPL: 0, limitedCount: 0, limitedCountPL: 0}
          }
          const minRate = (country === 'PL' ? priceStats.limit.PLN : priceStats.limit.EUR) || 0;
          prev[skillId] = Object.assign(prev[skillId], {
            ['count' + country]: prev[skillId]['count' + country] + 1,
            ['limitedCount' + country]: prev[skillId]['limitedCount' + country] + (rate < minRate ? 1 : 0),
            // avg: prev[skillId].avg + rate,
            ['min' + country]: rate > prev[skillId]['min' + country] ? prev[skillId]['min' + country] : rate
          });
        });
      }
      return prev;
    }, {});
    const skills = Object.values(this.$store.state.skills);

    this.stats = skills.map((skill) => {
      this.skills[skill.id] = skill;
      const skillStats = stats[skill.id] || {count: 0, avg: 0};
      const priceStats = Object.assign({limit: {EUR: 0, PLN: 0}, minimum: {EUR: 0, PLN: 500}}, skill.priceStats);
      const minEur = parseInt(priceStats.minimum.EUR / 100 / 0.8);
      const limitEur = priceStats.limit.EUR / 100;
      const minPln = parseInt((priceStats.minimum.PLN || 0) / 100 / 0.8);
      const limitPln = (priceStats.limit.PLN || 0) / 100;
      this.rangesLT[skill.id] = [minEur, limitEur];
      this.rangesPL[skill.id] = [minPln, limitPln];
      // let avgRate;
      // if (skillStats.count) {
      //   avgRate = skillStats.avg / skillStats.count / 100;
      // } else {
      //   avgRate = 0;
      // }

      const config = Object.keys(skill).reduce((prev, next) => {
          if (next.startsWith('order')) {
            return prev + '<b>' + next + '</b> ' + JSON.stringify(skill[next]) + '<br />';
          } else {
            return prev;
          }
        }, '');

      return {
        id: skill.id,
        config,
        serviceId: skill.serviceId,
        hourlyRate: skill.hourlyRate,
        hourlyRate2: skill.hourlyRate2,
        hidden: skill.hidden,
        from: skill.from,
        count: skillStats.count,
        countPL: skillStats.countPL, 
        limitedCount: skillStats.limitedCount, 
        limitedCountPL: skillStats.limitedCountPL, 
        // avg: Number(avgRate).toFixed(2), 
        min: (skillStats.min || 0) / 100,
        minRate: parseInt((skillStats.min || 0) / 0.8),
        priceStats: Object.assign({from: {EUR: 0}, limit: {EUR: 0}, minimum: {EUR: 0}}, skill.priceStats),
        service: skill.serviceId, title: skill.localizedTitle.lt || skill.title};
    }).sort((s1, s2) => {
      if ( s1.serviceId < s2.serviceId ){
        return -1;
      }
      if ( s1.serviceId > s2.serviceId ){
        return 1;
      }
      return 0;
    });

    // console.log(this.orders.map((order, i) => ({...order, id: i})));
  },
  // components: {
  //   HelloWorld
  // }
}
</script>
